"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MidnightsGazeAbilityHandler = exports.MidnightsGazeActorAbilityFactory = exports.MidnightsGazeAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Darkness_1 = require("../../core/effects/core/Darkness");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class MidnightsGazeAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.MidnightsGaze;
        this.__typeName = "MidnightsGaze";
    }
}
exports.MidnightsGazeAbilityArgs = MidnightsGazeAbilityArgs;
let MidnightsGazeActorAbilityFactory = class MidnightsGazeActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("MidnightsGaze", "OneEnemies", 0);
    }
};
MidnightsGazeActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("MidnightsGaze")
], MidnightsGazeActorAbilityFactory);
exports.MidnightsGazeActorAbilityFactory = MidnightsGazeActorAbilityFactory;
let MidnightsGazeAbilityHandler = class MidnightsGazeAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "magic",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Death", 45)
            ],
            onHit(sequence) {
                sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet"), "EngulfingDarkness"));
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Turns(2),
                    effect: new Darkness_1.DarknessEffectArgs(1)
                });
            }
        });
    }
};
MidnightsGazeAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.MidnightsGaze)
], MidnightsGazeAbilityHandler);
exports.MidnightsGazeAbilityHandler = MidnightsGazeAbilityHandler;
